import { Component } from '@angular/core';

@Component({
  selector: 'app-section-aluno-a-empresario',
  templateUrl: './section-aluno-a-empresario.component.html',
  styleUrls: ['./section-aluno-a-empresario.component.scss'],
})
export class SectionAlunoAEmpresarioComponent {}
